import { SsoLoginInput } from '../../lib/types/models/auth/login'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function ssoLogin(data: SsoLoginInput) {
  return restApiClient
    .url(constructApiUrl(API.auth['sso-login'].url, null))
    .post<never, SsoLoginInput>(data)
}
